import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export const LoaderDots = ({ render, pattern = ['..', '...', '....'], speed = 400 }) => {
    const [index, setIndex] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % pattern.length);
        }, speed);
        return () => clearInterval(timer);
    }, [pattern, speed]);
    const dots = pattern[index];
    return _jsx(_Fragment, { children: render(dots) });
};
